"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StorageError = exports.RetrofitAccountError = exports.PaymentError = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _Container = _interopRequireDefault(require("./components/Container"));
var _excluded = ["goToSettings", "onClose"],
  _excluded2 = ["isImporting", "onUpgrade", "onClose"],
  _excluded3 = ["message", "isLoading", "onReconnect"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ErrorBanner = function ErrorBanner(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$transparent = _ref.transparent,
    transparent = _ref$transparent === void 0 ? false : _ref$transparent;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    variant: "error",
    transparent: transparent,
    className: (0, _classnames["default"])({
      'opacity-50 cursor-default': isLoading
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-center font-light text-sm"
  }, children), !(0, _isNil["default"])(onClose) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute right-0 w-12 cursor-pointer",
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_Clear["default"], null)));
};
var PaymentError = exports.PaymentError = function PaymentError(_ref2) {
  var goToSettings = _ref2.goToSettings,
    onClose = _ref2.onClose,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(ErrorBanner, (0, _extends2["default"])({}, props, {
    onClose: onClose
  }), t('premium.payment.errorBanner'), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-3 font-bold cursor-pointer",
    onClick: goToSettings
  }, t('premium.payment.errorBanner.goToSettings')));
};
var StorageError = exports.StorageError = function StorageError(_ref3) {
  var isImporting = _ref3.isImporting,
    onUpgrade = _ref3.onUpgrade,
    onClose = _ref3.onClose,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded2);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var content = (0, _react.useMemo)(function () {
    if (!onUpgrade) {
      return t('premium.storage.errorBanner.noUpgrade');
    } else if (isImporting) {
      return t('premium.storage.errorBanner.importAccounts');
    } else {
      return t('premium.storage.errorBanner');
    }
  }, [isImporting, onUpgrade]);
  return /*#__PURE__*/_react["default"].createElement(ErrorBanner, (0, _extends2["default"])({}, props, {
    onClose: onClose
  }), content, onUpgrade && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-3 font-bold cursor-pointer",
    onClick: onUpgrade
  }, t('premium.storage.errorBanner.upgrade')));
};
var RetrofitAccountError = exports.RetrofitAccountError = function RetrofitAccountError(_ref4) {
  var message = _ref4.message,
    isLoading = _ref4.isLoading,
    onReconnect = _ref4.onReconnect,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded3);
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(ErrorBanner, (0, _extends2["default"])({}, props, {
    isLoading: isLoading
  }), message, onReconnect && /*#__PURE__*/_react["default"].createElement("button", {
    className: (0, _classnames["default"])('font-bold ml-3', {
      'cursor-default opacity-75': isLoading
    }),
    disabled: isLoading,
    onClick: onReconnect
  }, t('button.retry')));
};
var _default = exports["default"] = ErrorBanner;
//# sourceMappingURL=Error.js.map